import AMBKingGames from './AMBKingGames'

export default AMBKingGames
